<div class = "row headingStyle">
<div class= "col-md-4"> <a (click)="gotoAuditPage()">Back</a></div>   
<div class= "col-md-12 centerAlign">
<h4>Application Details - {{applicationId}}</h4>
</div>
</div>

<div class = "row tableRowAlign">
 
    <table class="my-table tableWidth">
        <thead class="my-table centerAlign">
          <tr class="tableHeader">
            <th class ="colCell">Integration Audit Id</th>
            <th class ="colCell">Request Type</th>
            <th class ="colCell">Status</th>
            <th class ="colCell">Created On</th>
            <th class ="colCell">Response</th>
            <th class ="colCellLeft">Request</th>
          </tr>
        </thead>
        <tbody class="my-table centerAlign">
            <tr class="tableRow" *ngFor="let row of rJson;  index  as i ">
                <td class ="colCell">
                    {{row.integration_audit_id}}
                </td>
                <td class ="colCell">
                    {{row.requestType}}  
                </td>
                <td class ="colCell">
                    {{row.status}}
                </td>
                <td class ="colCell">
                    {{row.createdOn}}
                </td>
                <td class ="colCell">
                    <button class="auditTableButton" (click)="viewRequest(row.integration_audit_id)" >View Request</button>
                </td>
                <td class ="colCellLeft">
                    <button class="auditTableButton" (click)="viewResponse(row.integration_audit_id)" >View Response</button>
                </td>
            </tr>
        </tbody>
    </table>

</div>
